/* eslint-disable import/no-cycle */
import { APIServiceAllRoles } from './ApiService';

export const checkServerHealth = () => APIServiceAllRoles.get('/healthcheck');
